<template>
	<a-layout-header style="background: #fff; padding: 0;line-height: 90px;height: 90px;min-width: 1224px;">
		<a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'" @click="toggleCollapsed" />
		<!-- <a-input-search placeholder="Search" style="width: 200px" @search="onSearch" /> -->
		<a-select :value="now_app_state" style="width: 220px" @change="onSearch">
			<a-select-option value="all">
				全部
			</a-select-option>
			<a-select-option :value="app.id" v-for="app in apps_list" :key="app.id">
				{{app.app_name}}
			</a-select-option>
		</a-select>
		<div style="float: right;width: 300px;height: 100%;margin-right: 15px;position: relative;">
			<div style="float: right;display: inline-block;">
				<a-avatar :size="64" shape="circle" :src="userinfo.avatar" v-if="userinfo.avatar" />
				<a-avatar :size="64" icon="user" v-else />
			</div>
			<div style="float: right; display: inline-block;margin-right: 10px;line-height: 30px;margin-top: 15px;">
				<span style="font-size: 14px;">{{ userinfo.email }}</span>
				<a-dropdown style="margin-left: 50px;">
					<a class="ant-dropdown-link tophover" href="#">
						更多操作
						<a-icon type="down" />
					</a>
					<a-menu slot="overlay">
						<a-menu-item><a href="javascript:;">二次认证</a></a-menu-item>
						<a-menu-item>
							<router-link to="forgotpassword"><span>修改密码</span></router-link>
						</a-menu-item>
						<a-menu-item><span @click="quit">退出登录</span></a-menu-item>
					</a-menu>
				</a-dropdown>
			</div>
		</div>
	</a-layout-header>
</template>

<script>
	export default {
		data() {
			return {
				collapsed: this.$store.state.collapsed || false,
				apps_list: [],
				now_app_state: this.$store.state.now_app_state || 'all'
			};
		},
		name: 'topBar',
		props: {
			fatherMethod: {
				type: Function,
				default: null
			},
		},
		computed: {
			userinfo: function() {
				return JSON.parse(sessionStorage.getItem('userinfo'));
			}
		},
		created: function() {
			var self = this;
			if (!this.$store.state.apps_list) {
				this.$axios.get('/basic/getapps').then(function(res) {
					self.apps_list = res.data.apps_list;
					self.$store.state.apps_list = res.data.apps_list;
				})
			} else {
				this.apps_list = this.$store.state.apps_list
			}
		},
		methods: {
			toggleCollapsed() {
				this.collapsed = !this.collapsed;
				this.$store.state.collapsed = this.collapsed;
			},
			quit() {
				sessionStorage.removeItem('userinfo');
				localStorage.removeItem('username');
				localStorage.removeItem('password');
				this.$router.push('login');
			},
			onSearch(value) {
				this.now_app_state = value
				this.$store.state.now_app_state = this.now_app_state;
				this.childMethod();
			},
			childMethod() {
				if (this.fatherMethod) {
					this.fatherMethod();
				}
			}

		}
	};
</script>

<style>
	.trigger {
		font-size: 18px;
		line-height: 64px;
		padding: 0 24px;
		cursor: pointer;
		transition: color .3s;
	}

	.trigger:hover {
		color: #1890ff;
	}

	.tophover {
		font-size: 14px;
		display: block;
		font-size: 12px;
		color: #666666;
	}
</style>



// WEBPACK FOOTER //
// top_bar.vue?69bcfd2a